@if (value && value > 0) {
    <div
        class="icon"
        [ngClass]="divClass"
        [ngStyle]="divStyle"
        [pTooltip]="tooltip"
        [tooltipDisabled]="!tooltip || tooltipDisabled"
        [tooltipPosition]="tooltipPosition"
        [value]="value"
        pBadge
        tooltipEvent="hover"
    >
        @if (href) {
            <svg
                [ngClass]="ngClass"
                [ngStyle]="style"
            >
                <use [attr.href]="href"></use>
            </svg>
        }
    </div>
}

@if (!value || (value && value == 0)) {
    <div
        class="icon"
        [ngClass]="divClass"
        [ngStyle]="divStyle"
        [pTooltip]="tooltip"
        [tooltipDisabled]="!tooltip || tooltipDisabled"
        [tooltipPosition]="tooltipPosition"
        tooltipEvent="hover"
    >
        @if (href) {
            <svg
                [ngClass]="ngClass"
                [ngStyle]="style"
            >
                <use [attr.href]="href"></use>
            </svg>
        }
    </div>
}
